export const reorder = (
  list: any[],
  startIndex: number,
  endIndex: number
): any[] => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

export const move = (
  source: any,
  destination: any,
  droppableSource: any,
  droppableDestination: any
) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result: any = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};

export const colors = ["#149ECD", "#F7964F", "#F2353C", "#673AB7", "#8BC34A"];
export const lightColors = ["#E6F5FA", "#FDEEE2", "#FCE4E5", "#EEE9F7", "#EFF7E7"];

export const getContainerHeight = (item: HTMLElement | null) => {
  const height = item ? item.getBoundingClientRect().y + 24 : 0;
  return `calc(100vh - ${height + "px"}) `;
};

export const displayNamesMap = {
  serviceType: "Service Type*",
  service: "Service*",
  taskType: "Task Type*",
  client: "Client*",
  startDate: "Start Date*",
  dueDate: "Due Date*",
  expectedCompletionDate: "Expected Completion Date",
  financialYear: "Financial Year",
  users: "Users*",
  approvals: "Approvals",
  category: "Service Category",
  subCategory: "Service Sub-Category",
};
export const displayNamesMapIt = {
  client: "Client Name *",
  gstNumber: "GSTIN",
  panNumber: "PAN",
  panPassword: "PAN Password",
  tanNumber: "TAN",
  tanPassword: "TAN Password",
  gstUsername: "GST Username",
  gstPassword: "GST Password",
  tracesTan: 'Traces TAN',
  tracesPassword: 'Traces Password',
  isComplianceApplicable:'Compliance Portal',
  gstatUsername: 'GSTAT Username',
  gstatPassword: 'GSTAT Password',
};

export const mandatoryFields = [
  "client",
];
export const ServiceType = [
  { id: 1, name: "standard" },
  { id: 2, name: "custom" },
];

export const feeType = [
  { id: 1, name: "TOTAL" },
  { id: 2, name: "HOURLY" },
];

export const taskType = [
  { id: 1, name: "non_recurring" },
];

export const priorityType = [
  { id: 1, name: "high" },
  { id: 2, name: "medium" },
  { id: 3, name: "low" },
  { id: 4, name: "none" },
];

export const isDateColumn = (fieldName: string) =>
  ["startDate", "dueDate", "expectedCompletionDate*"].includes(fieldName);

export const isDscDateColumn = (fieldName: string) => ["expiryDate"].includes(fieldName);

export const isDropdownColumn = (fieldName: string) =>
  [
    "serviceType",
    "taskType",
    "client",
    "financialYear",
    "users",
    "taskLeader",
    "priority",
    "feeType",
    "approvals",
    "category",
    "subCategory"
  ].includes(fieldName);

export const dscDropDownColumn = (fieldName: string) => [
  "clients"
].includes(fieldName);




export const isDropdownColumnIt = (fieldName: string) =>
  [
    'client',
  ].includes(fieldName);

export const desiredOrder = [
  'slNo',
  'client',
  'taskType',
  'serviceType',
  'category',
  'subCategory',
  'service',
  'startDate',
  'dueDate',
  'expectedCompletionDate',
  'financialYear',
  'users',
  'taskLeader',
  'priority',
  'feeType',
  'serviceFee',
  'approvals',
];
export const desiredOrderIt = [
  'slNo',
  'client',
  'isComplianceApplicable',
  'panNumber',
  'panPassword',
  'tanNumber',
  'tanPassword',
  'gstNumber',
  'gstUsername',
  'gstPassword',
  'tracesTan',
  'tracesPassword',
  'gstatUsername',
  'gstatPassword',
];

export const requiredColumns = [
  "Users*",
  "Client*",
  "Service*",
  "Approvals",
  "Task Leader",
  "Task Type*",
  "Fee Type",
  "Priority",
  "Financial Year* (YYYY-YYYY)",
  "Expected Completion Date (DD-MM-YYYY)",
  "Statutory Due Date* (DD-MM-YYYY)",
  "Start Date* (DD-MM-YYYY)",
  "Service Type*",
  "Service Fee",
  "Service Category",
  "Service Sub Category",
];
export const requiredColumnsIt = [
  "Client Name *",
  "PAN",
  "PAN Password",
  "TAN",
  "TAN Password",
  "GSTIN",
  "GST Username",
  "GST Password",
  "Traces Password",
  "Traces TAN"
];


export const requiredDscColumns = [
  'DSC Holder Name *',
  'DSC Holder Designation',
  'Country Code *',
  'Mobile Number *',
  'Email ID',
  'Expiry Date* (DD-MM-YYYY)',
  'Password *',
  'PAN',
]

export const deseredDscOrder = [
  // 'slNo',
  'dscTokenNumber',
  'dscHolderName',
  "clients",
  'dscHolderDesignation',
  'countryCode',
  'mobileNumber',
  'email',
  'expiryDate',
  'password',
  'pan'

]

export const dscDisplayNamesMap = {
  dscTokenNumber: 'DSC Token Number',
  clients: "Client Name(s)",
  dscHolderName: "DSC Holder Name *",
  dscHolderDesignation: 'DSC Holder Designation',
  countryCode: 'Country Code *',
  mobileNumber: 'Mobile Number *',
  email: 'Email ID',
  expiryDate: 'Expiry Date* (DD-MM-YYYY)',
  password: 'Password *',
  pan: 'PAN'










}
